import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import BlockUi from 'react-block-ui';
import { Helmet } from 'react-helmet';
import GuestBox from '../../components/GuestBox';
import Link from '../../components/Link';
import ButtonField from '../../components/ButtonField';
import TextField from '../../components/LogingTextField';
import logo from '../../assets/vb-logo.png';
import {
  createLoadingSelector,
  createErrorMessageSelector,
  resetTokenSelector,
} from '../Main/reducer';
import { RESET_PASSWORD_REQUEST, resetPasswordRequest } from './actions';

class ResetPasswordPage extends React.Component {
  componentDidMount() {
    const { location, resetToken } = this.props;
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    if (!token && !resetToken) {
      this.props.history.push('/forgot-password');
    }
  }

  handleFormSubmit = (values) => {
    const { location, resetToken } = this.props;
    const params = new URLSearchParams(location.search);
    const token = params.get('token') || resetToken;
    this.props.resetPasswordRequest({ ...values, token });
  };

  render() {
    const { handleSubmit, loading, error } = this.props;

    return (
      <BlockUi blocking={loading}>
        <Helmet>
          <title>Reset Password | VoiceboxMD Web</title>
          <meta
            name="description"
            content="Set a new password for your account."
          />
        </Helmet>
        <GuestBox>
          <img
            src="./favicon.ico"
            alt="VoiceboxMD Logo"
            style={{ width: '25px', marginBottom: '1rem' }}
          />
          <img
            src={logo}
            alt="VoiceboxMD Logo"
            style={{ width: '150px', marginBottom: '1rem' }}
          />
          <div className="title mb-4">
            <FormattedMessage
              id="ResetPasswordPage.title"
              defaultMessage="Reset Password"
            />
          </div>
          {error && (
            <div className="text-danger mb-3">
              <FormattedMessage
                id="ResetPasswordPage.error"
                defaultMessage={error || 'An error occurred. Please try again.'}
              />
            </div>
          )}
          <FormattedMessage
            id="ResetPasswordPage.newPassword"
            defaultMessage="New Password"
          >
            {(msg) => (
              <Field
                name="newPassword"
                component={TextField}
                placeholder={msg}
                className="mb-4"
                type="password"
                validate={[this.passwordValidator]}
              />
            )}
          </FormattedMessage>
          <FormattedMessage
            id="ResetPasswordPage.confirmPassword"
            defaultMessage="Confirm Password"
          >
            {(msg) => (
              <Field
                name="confirmPassword"
                component={TextField}
                placeholder={msg}
                className="mb-4"
                type="password"
                validate={[this.passwordValidator]}
              />
            )}
          </FormattedMessage>
          <ButtonField
            className="mb-3"
            onClick={handleSubmit(this.handleFormSubmit)}
            disabled={loading}
          >
            <FormattedMessage
              id="ResetPasswordPage.submit"
              defaultMessage="Reset Password"
            />
          </ButtonField>
          <Link
            bold
            onClick={() => this.props.history.push('/login')}
            className="forgot"
          >
            <FormattedMessage
              id="ResetPasswordPage.login"
              defaultMessage="Return to Login"
            />
          </Link>
        </GuestBox>
      </BlockUi>
    );
  }

  passwordValidator = (value) => {
    return value && value.length >= 6
      ? undefined
      : 'Password must be at least 6 characters';
  };
}

ResetPasswordPage = reduxForm({
  form: 'resetPassword',
  validate: (values) => {
    const errors = {};
    if (!values.newPassword || values.newPassword.length < 6) {
      errors.newPassword = 'Password must be at least 6 characters';
    }
    if (
      !values.confirmPassword ||
      values.confirmPassword !== values.newPassword
    ) {
      errors.confirmPassword = 'Passwords must match';
    }
    return errors;
  },
})(ResetPasswordPage);

ResetPasswordPage = connect(
  createStructuredSelector({
    loading: createLoadingSelector([RESET_PASSWORD_REQUEST]),
    error: createErrorMessageSelector([RESET_PASSWORD_REQUEST]),
    resetToken: resetTokenSelector,
  }),
  { resetPasswordRequest }
)(ResetPasswordPage);

export default ResetPasswordPage;
